// Ephemeral toast — auto-dismisses after `durationMs`. Re-fires the
// dismiss timer when `id` changes so consecutive toasts of the same
// message still get a fresh window.

import { useEffect } from "react";
import { clsx } from "clsx";
import type { ToastKind } from "../state/store";
import { TOAST_DURATION_MS } from "../config";

const KIND_CLASSES: Record<ToastKind, string> = {
  ok: "bg-black/80",
  warn: "bg-[color:var(--warn)]/85",
  error: "bg-[color:var(--err)]/85",
};

export function Toast({
  id,
  message,
  kind = "ok",
  durationMs = TOAST_DURATION_MS,
  onDone,
}: {
  id: number;
  message: string;
  kind?: ToastKind;
  durationMs?: number;
  onDone: () => void;
}) {
  useEffect(() => {
    const t = setTimeout(onDone, durationMs);
    return () => clearTimeout(t);
  }, [id, durationMs, onDone]);
  return (
    <div
      role="status"
      data-testid="toast"
      data-kind={kind}
      className={clsx(
        "fixed bottom-4 right-4 px-3 py-2 rounded text-fg text-xs shadow-lg",
        KIND_CLASSES[kind],
      )}
    >
      {message}
    </div>
  );
}
